import React from 'react';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserLock } from '@fortawesome/pro-light-svg-icons/faUserLock';
import { Formik, Form, Field } from 'formik';
import LinkButton from '../common/Buttons/LinkButton';
import Input from '../common/Formik/Input';

class ChangePasswordArea extends React.Component {
  validationSchema = () => {
    const { t } = this.props;
    return Yup.object().shape({
      old: Yup.string()
        .required(t('validationRequired'))
        .min(8, t('validationPasswordLength', { amount: 8 })),
      new: Yup.string()
        .required(t('validationRequired'))
        .min(8, t('validationPasswordLength', { amount: 8 }))
        .matches(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/, {
          message: t('validationPasswordStrength'),
          excludeEmptyString: true,
        }),
      confirm: Yup.string()
        .required(t('validationRequired'))
        .oneOf([Yup.ref('new'), null], t('validationPasswordEqual')),
    });
  };

  handleSubmit = (values) => {
    const { onSubmit } = this.props;
    onSubmit(values);
  };

  render() {
    const { passwordInfo, onConfirm, onCancel, t } = this.props;

    return (
      <Formik validationSchema={this.validationSchema()} initialValues={passwordInfo} onSubmit={this.handleSubmit}>
        {() => (
          <Form autoComplete="off">
            <div className="settings-list editing">
              <h1>
                <span>
                  <FontAwesomeIcon icon={faUserLock} />
                  &nbsp; {t('labelChangePassword')}
                </span>
                <LinkButton className="edit-button" onClick={onCancel}>
                  {t('labelGoBack')}
                </LinkButton>
              </h1>
              <div className="settings-list__item">
                <span className="label">{t('labelOldPassword')}</span>
                <span className="input">
                  <Field name="old" component={Input} type="password" withIcon canToggleIcon autoComplete="off" />
                </span>
              </div>
              <div className="settings-list__item">
                <span className="label">{t('labelNewsPassword')}</span>
                <span className="input">
                  <Field name="new" component={Input} type="password" withIcon canToggleIcon autoComplete="off" />
                </span>
              </div>
              <div className="settings-list__item">
                <span className="label">{t('labelConfirmPassword')}</span>
                <span className="input">
                  <Field name="confirm" component={Input} type="password" withIcon canToggleIcon autoComplete="off" />
                </span>
              </div>
              <div className="text-right pt-2">
                <button type="submit" className="btn btn-secondary" onClick={onConfirm}>
                  {t('labelConfirm')}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

export default ChangePasswordArea;
